import { render, staticRenderFns } from "./TempoOrders.vue?vue&type=template&id=706597fb&scoped=true&"
import script from "./TempoOrders.vue?vue&type=script&lang=js&"
export * from "./TempoOrders.vue?vue&type=script&lang=js&"
import style0 from "./TempoOrders.vue?vue&type=style&index=0&id=706597fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706597fb",
  null
  
)

export default component.exports